import {Link} from "react-router-dom";
import i18n from "../i18n";
import React from "react";


class ProductItemDiscountBasket extends React.Component
{
    constructor(props) {
        super(props);
    }

    render() {
        const product = this.props.product;
        return <div
            className="product"
        >
            <div
                className="image"
                style={{backgroundImage: "url('" + product.thumbnail + "')"}}
            ></div>
            <div className="info">
                <Link
                    to={`/products/${product.id}`}
                    className="name"
                >
                    <span className="fs-sm">&times;{product.quantity}</span>
                    &nbsp;
                    {i18n.get_name(product)}
                </Link>
                <span className="price">
                        <span>{product.quantity} {i18n.t("qty_metric")}</span> {i18n.t("from")} <span className='original-price'>{parseFloat(product.price).toFixed(2)} €</span> {this.props.calculateDiscountPrice(product) > 0 ? '(' + this.props.calculateDiscountPrice(product).toFixed(2) + ' €/'+i18n.t("qty_metric_single")+')' : <b>{i18n.t("free")}</b>}
                      </span>
                <span className="price" style={{margin: '5px 0', fontWeight: 600}}>
                        {this.props.calculateTotalProductDiscountPrice(product) > 0 ? this.props.calculateTotalProductDiscountPrice(product).toFixed(2) + '€ ' + i18n.t("total") : ''}
                      </span>
                <div className="controls">

                    <button
                        type="button"
                        className="btn btn-sm btn-outline"
                        onClick={() => this.props.removeDiscountProduct(product)}
                    >
                        {i18n.t('remove_product_from_basket')}
                    </button>
                </div>
            </div>
        </div>
    }
}

export default ProductItemDiscountBasket;